import React from "react";
import { CustomTopBarProps } from "../../external/ensolvers-core-frontend-mui/components/Main/AppContainer";
import { getSections } from "../../utils/NavigationUtils";
import { useFeatureToggle } from "../../external/ensolvers-core-frontend-mui/hooks/useFeatureToggle";
import featureToggleList from "../../utils/toggleConfig.json";
import { Features } from "../../utils/Features";
import { UserInfoContext } from "../../context/UserInfoContext";
import { NavPill } from "./NavPill";

export const ShellTopBar: React.FC<CustomTopBarProps> = ({ handleSignOut }) => {
  const user = React.useContext(UserInfoContext)?.user;
  const [dashboard] = useFeatureToggle(featureToggleList, Features.DASHBOARD_FEATURE);
  const [vacationReport] = useFeatureToggle(featureToggleList, Features.VACATION_REPORT);
  const [accomplishments] = useFeatureToggle(featureToggleList, Features.ACCOMPLISHMENTS);
  const [certifications] = useFeatureToggle(featureToggleList, Features.CERTIFICATIONS);
  const [darkMode] = useFeatureToggle(featureToggleList, Features.DARK_MODE);

  if (!user?.externalId) return null;

  return (
    <NavPill
      sections={getSections(user, dashboard, vacationReport, accomplishments, certifications)}
      handleSignOut={handleSignOut}
      showThemeToggle={!!darkMode}
    />
  );
};
